'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import Tooltip from '@/app/_components/Tooltip';
import { useAppContext } from '@/app/_lib/_context';
import { useTradePricing } from '@/app/_lib/hooks';

/**
 * Simple trade pricing link for non-trade users
 * Shows "Trade Pricing: Apply or Sign In" below the price
 * Returns null for verified trade accounts
 */
const TradePricingLink = t0 => {
  const $ = _c(13);
  const {
    className: t1,
    supplierId: t2,
    subProductId: t3
  } = t0;
  const className = t1 === undefined ? "" : t1;
  t2 === undefined ? null : t2;
  const subProductId = t3 === undefined ? null : t3;
  const {
    openSignInModal
  } = useAppContext();
  let t4;
  if ($[0] !== subProductId) {
    t4 = {
      subProductId
    };
    $[0] = subProductId;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    loading,
    isSignedIn,
    isTradeAccount
  } = useTradePricing(t4);
  if (loading) {
    return null;
  }
  if (isTradeAccount) {
    return null;
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <><div className="flex items-center mb-2"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-lg mr-2" /><span className="text-sm font-medium text-main">Trade Program</span></div><p className="text-sm text-ink-light-gray-bg mb-0">Welcome, design professionals. Apply for a trade account and a specialist will be in touch shortly.</p></>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const applyTooltipContent = t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <><div className="flex items-center mb-2"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-lg mr-2" /><span className="text-sm font-medium text-main">Trade Program</span></div><p className="text-sm text-ink-light-gray-bg mb-0">Trade professionals please sign in.</p></>;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const signInTooltipContent = t6;
  if (!isSignedIn) {
    const t7 = `text-3xs text-light ${className}`;
    let t8;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Tooltip content={applyTooltipContent} side="bottom" mobileMode="disabled"><Link href="/hive-trade-program" className="underline hover:text-primary">Apply</Link></Tooltip>;
      $[4] = t8;
    } else {
      t8 = $[4];
    }
    let t9;
    if ($[5] !== openSignInModal) {
      t9 = <Tooltip content={signInTooltipContent} side="bottom" mobileMode="disabled"><button onClick={openSignInModal} className="underline hover:text-primary">Sign In</button></Tooltip>;
      $[5] = openSignInModal;
      $[6] = t9;
    } else {
      t9 = $[6];
    }
    let t10;
    if ($[7] !== t7 || $[8] !== t9) {
      t10 = <div className={t7}>Trade Program,{" "}{t8}{" "}or{" "}{t9}</div>;
      $[7] = t7;
      $[8] = t9;
      $[9] = t10;
    } else {
      t10 = $[9];
    }
    return t10;
  }
  const t7 = `text-3xs text-light ${className}`;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Tooltip content={applyTooltipContent} side="bottom" mobileMode="disabled"><Link href="/hive-trade-program" className="underline hover:text-primary">Apply</Link></Tooltip>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <div className={t7}>Trade Program,{" "}{t8}</div>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default TradePricingLink;